<script>
import { mapGetters, mapState, mapActions } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
    ...mapState('assistantWizard', ['channelConfig', 'error']),
    webhookUrl() {
      if (!this.channelConfig.api) {
        return null;
      }

      return this.channelConfig.api.webhook_url;
    },
  },
  methods: {
    ...mapActions('assistantWizard', ['next', 'updateChannelConfigItem']),
    inputConfigItem(e) {
      this.updateChannelConfigItem({
        channel: 'api',
        item: e.target.name,
        value: e.target.value,
      });
    },
    webhookError() {
      return this.error === 'webhook_url';
    },
  },
};
</script>

<template>
  <section class="flex items-center flex-col">
    <form
      class="flex flex-col w-full flex-1 mb-4 items-center"
      @submit.prevent="next()"
    >
      <label
        class="text-xl text-center text-slate-900 dark:text-slate-50 mb-8"
        for="webhook_url"
      >
        {{ $t('ASSISTANT_MGMT.WIZARD.CHANNELS.API.WEBHOOK_URL_LABEL') }}
      </label>
      <input
        id="webhook_url"
        :value="webhookUrl"
        class="rounded-md border-2 border-slate-100 text-center p-2 w-80 h-10 leading-10"
        name="webhook_url"
        @input="inputConfigItem"
      />
      <span v-if="webhookError()" class="message">
        {{ $t('ASSISTANT_MGMT.WIZARD.CHANNELS.API.WEBHOOK_URL_ERROR') }}
      </span>
      <p class="mt-2">
        Configure the URL where you want to receive callbacks on events.
      </p>
    </form>
  </section>
</template>
